// src/app/core/interceptors/auth.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { ADD_AUTH } from '../app-config.token';

const TOKEN_KEY = 'identity.token';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // ¿Esta request pide auth?
  const needsAuth = req.context.get(ADD_AUTH);
  if (!needsAuth) return next(req);

  // Lee el token desde sessionStorage
  const token = sessionStorage.getItem(TOKEN_KEY);
  if (!token) return next(req); // sin token, no modifica

  // Si ya hay Authorization, respeta (por si envías otra cosa)
  if (req.headers.has('Authorization')) return next(req);

  const authReq = req.clone({
    setHeaders: { Authorization: `Bearer ${token}` }
  });
  return next(authReq);
};
